<template>
  <div class="device">
    <div class="left" id="device_left">
      <div class="number total">
        <span class="artistic_font_numbers">{{ data?.total }}</span>
        个
      </div>
      <div class="gray_text">设备总数</div>
    </div>
    <div class="right">
      <div class="right_top">
        <ChildComponent
          title="车载人脸"
          :info="data?.carMountedFacialRecognition"
        ></ChildComponent>
        <ChildComponent
          title="闸机"
          :info="data?.gateEquipment"
        ></ChildComponent>
        <ChildComponent
          title="防撞柱"
          :info="data?.liftingAntiCollisionPillar"
        ></ChildComponent>
      </div>
      <div class="right_bottom">
        <ChildComponent
          title="车牌识别"
          :info="data?.securityLaneIdentification"
        ></ChildComponent>
        <ChildComponent
          title="破胎器"
          :info="data?.tireCrushing"
        ></ChildComponent>
        <ChildComponent
          title="汽车衡系统"
          :info="data?.truckScales"
        ></ChildComponent>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {
    ref,
    onMounted,
    onUnmounted,
    defineExpose,
    defineComponent,
  } from 'vue'
  import { getDevice } from '@/api/dashboard'

  // 计算圆形半径
  function resize() {
    const parentElement = document.querySelector('.device')
    const circleElement = document.querySelector('#device_left')

    const parentWidth = parentElement.clientWidth
    const parentHeight = parentElement.clientHeight

    const diameter = Math.min(parentWidth / 3, (parentHeight * 2) / 3)
    circleElement.style.setProperty('--circle-diameter', diameter + 'px')
  }
  onMounted(resize)

  // 请求数据
  const data = ref()
  const timer = ref()
  async function fetch() {
    const res = await getDevice()
    if (res.success) {
      data.value = res.data
    }
  }
  onMounted(() => {
    fetch()
    timer.value = setInterval(fetch, 60 * 1000)
  })
  onUnmounted(() => clearInterval(timer.value))

  defineExpose({ resize })

  // 定义子组件
  const ChildComponent = defineComponent({
    props: {
      title: {
        type: String,
        required: true,
      },
      info: {
        type: Object,
        required: true,
      },
    },
    template: `
      <div v-if='info'>
        <div class="gray_text">{{ title }}</div>
        <div>
          <span class="number artistic_font_numbers">{{ info?.total }}</span> 个
        </div>
        <div>
          离线
          <span :class="(info?.offline ? 'red_number' : 'green_number')+' artistic_font_numbers'">
            {{ info?.offline }}
          </span>
          个
        </div>
      </div>
    `,
  })
</script>

<style lang="less" scoped>
  .device {
    display: flex;
    align-items: center;
    justify-content: space-around;
    /deep/ .number {
      color: #ffffff;
    }
    /deep/ .gray_text {
      color: #ffffff8c;
      font-size: 13px;
    }
    /deep/ .green_number {
      color: #00d900;
    }
    /deep/ .red_number {
      color: #e53200;
    }
    .left {
      display: flex;
      flex-direction: column;
      --circle-diameter: 0px; /* 占位符，通过JS设置 */
      width: var(--circle-diameter);
      height: var(--circle-diameter);
      border-radius: 50%;
      background: linear-gradient(135deg, #0a881d, #2ca155, #36d771);
      text-align: center;
      align-items: center;
      justify-content: center;
      .total {
        font-size: 20px;
      }
    }
    .right {
      height: 100%;
      flex: 0.8;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .right_top,
      .right_bottom {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
      }
    }
  }
</style>
